import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      title: string;
      content: string;
      closeFn: () => void;
      callbackLabel?: string;
      callbackFn?: () => void;
    }
  ) {}
}
